const _ = require('underscore/underscore-min');
const Utils = require('core-helpers/utils.js');
const BrowserStorageService = require('core-services/browser-storage-service.js');
const MarketingService = require('core-services/marketing-service.js');

/**
 * This service stores data across the webapp
 * or across pages in the homepage, in most of the cases, these
 * data are used to send events or to track the user.
 */
const SharedDataService = (function(root, doc, undefined) {


    /*
     * Private vars
     */
    const filename = 'shared-data-service.js';

    /**
     * Remove a given key
     * @param  {string} key
     */
    const remove = (key) => {
        BrowserStorageService.remove(key);
    };

    /**
     * Registration Onboarding
     */
    const storeRegistrationOnboarding = () => {
        BrowserStorageService.set('REGISTRATION_ONBOARDING');
    };

    /**
     * Payment page views
     */
    const storePremiumPageView = () => {
        BrowserStorageService.set('PAGE_VIEWED_PREMIUM');
    };

    const storePurchasePageView = () => {
        BrowserStorageService.set('PAGE_VIEWED_PURCHASE');
    };

    /**
     * Payment discount
     */
    const storeDiscountCoupon = (coupon) => {
        BrowserStorageService.set('DISCOUNT_COUPON', coupon);
    };

    const getDiscountCoupon = () => {
        return BrowserStorageService.get('DISCOUNT_COUPON');
    };

    /**
     * Store plan infos in the browser on the current session.
     * These data will be used on /purchase page
     * to request backend APIs and to display price.
     * @param  {Object} plan
     */
    const storeSelectedPlan = (plan) => {
        if (!Utils.isObject(plan)) {
            return false;
        }
        const _plan = JSON.stringify(plan);
        BrowserStorageService.set('SELECTED_PLAN', _plan);
    };

    /**
     * Returns the plan previously selected
     * @return {Object}
     */
    const getSelectedPlan = () => {
        const planData = BrowserStorageService.get('SELECTED_PLAN');
        return planData ? JSON.parse(planData) : null;
    };

    /**
     * Clear all payment stored data
     */
    const clearPaymentData = () => {

        // Remove page views
        remove('PAGE_VIEWED_PREMIUM');
        remove('PAGE_VIEWED_PURCHASE');

        // Clear discounts
        remove('DISCOUNT_COUPON');

        // Clear plan data
        remove('SELECTED_PLAN');

    };

    /**
     * This will look for Web referral attribution and will store it in the session data.
     * It would be use for registration attribution.
     * N.B.: We always keep the first found data on a session.
     */
    const storeMarketingData = () => {

        /**
         * If data has been found on the session already,
         * we don't overwrite it.
         */
        let marketingData = getMarketingData();
        if (marketingData) {
            return false;
        }

        marketingData = MarketingService.getData();
        if (marketingData) {
            const string = JSON.stringify(marketingData);
            BrowserStorageService.set('MARKETING_UTM', string);
        }

    };

    const getMarketingData = () => {
        const data = BrowserStorageService.get('MARKETING_UTM');
        return data ? JSON.parse(data) : null;
    };

    /**
     * User update after payment:
     * Some user may purchase a subscribtion for some
     * reasons and we store those reasons here.
     * (e.g.: User wants to learn a new language and we store
     * this language value here.)
     */
    const getUserUpdatePremiumReasonsData = () => {
        const data = BrowserStorageService.get('POST_PREMIUM_USER_DATA');
        return data ? JSON.parse(data) : null;
    };

    /**
     * Gets and returns the transaction ID needed to activate
     * a study plan after payment.
     * @return {String|null} transaction ID
     */
    const studyPlanGetTransactionID = () => {
        let transactionData = BrowserStorageService.get('STUDY_PLAN_ACTIVATION_DATA');
        transactionData = JSON.parse(transactionData);
        if (!transactionData || !transactionData.transaction_id) {
            return null;
        }

        return transactionData.transaction_id;
    };

    /**
     * Completely removes all activation data from localStorage
     * once a study plan has been successfully activated after a purchase.
     * NB: We also set a key that will trigger the study plan nav component to open on load
     */
    const studyPlanRemoveActivationData = () => {
        BrowserStorageService.set('STUDY_PLAN_FORCE_DROPDOWN');
        BrowserStorageService.remove('STUDY_PLAN_ACTIVATION_DATA');
    };

    /**
     * On Logout/Login/Registration, there's some keys that needs te be removed.
     * These are localStorage and sessionStorage keys.
     * Auth tokens are removed from PHP. These keys are purely product or Front-end related.
     * @param {String} type - 'login', 'logout' or 'register'
     */
    const clearSpecificKeys = (type) => {
        let mapTypes = {
            'logout': 'clearOnLogout',
            'login': 'clearOnLogin',
            'register': 'clearOnRegister'
        };
        const allkeys = BrowserStorageService.getAll();
        _.each(allkeys, (keyData, key) => {
            if(keyData[mapTypes[type]]){
                remove(key);
            }
        });
    };

    return {
        remove: remove,
        clearSpecificKeysAfterLogout: clearSpecificKeys.bind(null, 'logout'),
        clearSpecificKeysAfterLogin: clearSpecificKeys.bind(null, 'login'),
        clearSpecificKeysAfterRegistration: clearSpecificKeys.bind(null, 'register'),
        clearPaymentData: clearPaymentData,
        getDiscountCoupon: getDiscountCoupon,
        getSelectedPlan: getSelectedPlan,
        storeDiscountCoupon: storeDiscountCoupon,
        storeSelectedPlan: storeSelectedPlan,
        storePremiumPageView: storePremiumPageView,
        storePurchasePageView: storePurchasePageView,
        getMarketingData: getMarketingData,
        storeMarketingData: storeMarketingData,
        storeRegistrationOnboarding: storeRegistrationOnboarding,
        getUserUpdatePremiumReasonsData: getUserUpdatePremiumReasonsData,
        studyPlanGetTransactionID: studyPlanGetTransactionID,
        studyPlanRemoveActivationData: studyPlanRemoveActivationData
    };

})(window, document);

module.exports = SharedDataService;
